import { queryClient } from "@/queryClient"

type ConfirmTerminalParams = {
  serialNumber: string
}

type ConfirmTerminalResponse = {
  serialNumber: string
  clientName: string | null
  clientMid: string | null
}

export const confirmTerminal = async (
  params: ConfirmTerminalParams
) => {
  const { body } = await api.post<ConfirmTerminalResponse>(
    "/terminals/confirm/",
    { body: params }
  )

  queryClient.invalidateQueries({
    queryKey: [TERMINALS_QUERY_KEY],
  })

  return body
}
